<div
	highlight
	type="bg"
	class="details-header"
	[isPositive]="order?.side === this.orderSideEnum.BUY"
	[isNegative]="order?.side === this.orderSideEnum.SELL"
>
	<div class="left">
		<span class="value">{{ 'ordersInfo.side.' + order?.side | translate }}</span>
	</div>
	<div class="right">
		<span class="value">{{ 'ordersInfo.status.' + order?.status | translate }}</span>
	</div>
</div>
